module.exports = __webpack_public_path__ + "img/bg2@2x.d2e6bd64.png";